import * as React from 'react';
import CommonCard from '../../CheckoutAdditionalService/components/EveryPortLounge/CommonCard/CommonCard';
import { InfoMessageTypeEnum, NASProductCategory, NASStatus, PassengerFragment } from '@websky/graphql';
import { getNasServiceCardParams } from '../../CheckoutAdditionalService/components/EveryPortLounge/utils';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import { Money as MoneyType } from '../../types';
import { Money } from '../../Money';
import Notification from '../../Notification';
import { CdnIcon } from '@shared/ui';

interface Props {
	type: NASProductCategory;
	serviceName: {
		name: string;
		terminal?: string;
	};
	passengerNames: string[];
	travellers: PassengerFragment[];
	totalPrice: MoneyType;
	error?: string;
	ticketsNumber: number;
}

const NasServiceCard: React.FC<Props> = ({ type, serviceName, passengerNames, travellers, totalPrice, error }) => {
	const params = getNasServiceCardParams(type);
	const { t } = useTranslation('Refund');
	const { t: aasT } = useTranslation('ServiceAggregation');
	const theme = useTheme('CheckoutAdditionalService');

	const coverClassName = React.useMemo(() => {
		if (type === NASProductCategory.vip) {
			return theme.Vip.vip;
		}

		if (type === NASProductCategory.lounge) {
			return theme.Business.business_aggregator;
		}

		if (type === NASProductCategory.meet_and_greet) {
			return theme.MeetAndGreet.meet_and_greet;
		}

		if (type === NASProductCategory.fast_track) {
			return theme.FastTrack.fast_track_aggregator;
		}

		return null;
	}, [theme, type]);

	const renderHeaderPrice = () => {
		return (
			<span>
				{t('Exchange:Refund')}: <Money money={totalPrice} />
			</span>
		);
	};

	return (
		<CommonCard
			header={t(params.title)}
			description={t(params.description)}
			coverClassName={coverClassName}
			isSelected={true}
			isModifyAvailable={false}
			icons={params.icons}
			totalPrice={totalPrice}
			travellers={travellers}
			serviceType={type}
			selectedServicesText={[serviceName]}
			selectedServicesPassengerNames={passengerNames.map(name => ({
				name,
				status: NASStatus.Confirmed
			}))}
			selectedServicesDetailsLink={null}
			hideButtons={true}
			renderHeaderPrice={renderHeaderPrice}
			hideFooterButtons={true}
		>
			{!error && aasT('Entrance with boarding ticket')}

			{!!error && (
				<Notification
					status={InfoMessageTypeEnum.Warning}
					icon={<CdnIcon icon="Info/Not included" />}
					type="context"
					infoMessage={{
						title: t('Not refunded'),
						text: t(error),
						type: InfoMessageTypeEnum.Warning,
						code: 'notRefunded'
					}}
				/>
			)}
		</CommonCard>
	);
};

export default NasServiceCard;
